module.exports = __webpack_public_path__ + "img/tzsb1.3a3b1adf.png";